/**
 * winner-wfw-003 — Theme cart drawer: Figma / Convert parity (native #CartDrawer).
 * Threshold uses theme free-shipping bar setting (main currency); see Liquid JSON #WydeCartFigmaConfig.
 */
(function () {
  if (window.__WYDE_THEME_CART_FIGMA_INIT__) return;
  window.__WYDE_THEME_CART_FIGMA_INIT__ = true;

  var PAY_CARD_IMG = {
    visa:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/visa-65d650f7_svg.svg?v=1775660368',
    amex:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/american_express-1efdc6a3_svg.svg?v=1775660375',
    mc: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/master-54b5a7ce_svg.svg?v=1775660382',
    apple:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/apple_pay-1721ebad_svg.svg?v=1775660392',
    google:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/google_pay-34c30515_svg.svg?v=1775660398',
    paypal:
      'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/paypal-a7c68b85_svg.svg?v=1775660405',
    shop: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/shopify_pay-925ab76d_svg.svg?v=1775660410'
  };

  function getRoot() {
    return document.querySelector('#CartDrawer.wyde-amp-figma-cart');
  }

  function getCfg() {
    var el = document.getElementById('WydeCartFigmaConfig');
    if (!el || !el.textContent) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function thresholdCents() {
    var c = getCfg().thresholdCents;
    var n = typeof c === 'number' ? c : parseInt(c, 10);
    return n > 0 ? n : null;
  }

  function detectLang() {
    var h = document.documentElement.getAttribute('lang') || '';
    if (/^sv\b/i.test(h)) return 'sv';
    return 'en';
  }

  function formatProgressRemainingMoney(cart, amountCents) {
    var amount = amountCents / 100;
    var lang = detectLang();
    if (lang === 'sv' && cart.currency === 'SEK') {
      return (
        new Intl.NumberFormat('sv-SE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount) + ' kr'
      );
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: cart.currency
    }).format(amount);
  }

  function getRewardsEl(root) {
    var fs = root.querySelector('cart-drawer-free-shipping-bar-block.cart-drawer__free-shipping-bar');
    if (fs) {
      fs.classList.add('wyde-amp-figma-rewards--custom');
      return fs;
    }
    return root.querySelector('[data-wyde-rewards-fallback]');
  }

  function ensureProgressWrap(rewards) {
    var wrap = rewards.querySelector('.wyde-amp-figma-progress-wrap');
    if (wrap) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'wyde-amp-figma-progress-wrap';
    wrap.innerHTML =
      '<div class="wyde-amp-figma-rewards-text" aria-live="polite"></div>' +
      '<div class="wyde-amp-figma-progress-track">' +
      '<div class="wyde-amp-figma-progress-fill"></div>' +
      '</div>';
    rewards.insertBefore(wrap, rewards.firstChild);
    return wrap;
  }

  function removeProgressWrap(rewards) {
    var w = rewards.querySelector('.wyde-amp-figma-progress-wrap');
    if (w && w.parentNode) w.parentNode.removeChild(w);
  }

  function updateFooterShippingDisplay(freeShippingUnlocked) {
    var el = getRoot() && getRoot().querySelector('[data-wyde-shipping-value]');
    if (!el) return;
    var cfg = getCfg();
    var atCheckout = cfg.shippingAtCheckout || '';
    var freeLabel = cfg.shippingFree || '';
    if (freeShippingUnlocked) {
      el.textContent = freeLabel;
      el.classList.add('wyde-amp-figma-shipping-value--free');
    } else {
      el.textContent = atCheckout;
      el.classList.remove('wyde-amp-figma-shipping-value--free');
    }
  }

  function syncFooterShippingFromCart(cart) {
    var thresh = thresholdCents();
    if (!cart || !cart.currency || thresh == null) {
      updateFooterShippingDisplay(false);
      return;
    }
    var remaining = thresh - (cart.total_price || 0);
    updateFooterShippingDisplay(remaining <= 0);
  }

  function applyProgressFromCart(cart) {
    var root = getRoot();
    if (!root) return;
    var rewards = getRewardsEl(root);
    if (!rewards) return;

    var thresh = thresholdCents();
    if (!cart || !cart.currency || thresh == null) {
      removeProgressWrap(rewards);
      return;
    }

    var subtotal = cart.total_price || 0;
    var remaining = thresh - subtotal;
    var cfg = getCfg();
    var wrap = ensureProgressWrap(rewards);
    var textEl = wrap.querySelector('.wyde-amp-figma-rewards-text');
    var fillEl = wrap.querySelector('.wyde-amp-figma-progress-fill');

    if (remaining <= 0) {
      wrap.classList.add('wyde-amp-figma-progress-wrap--complete');
      textEl.innerHTML = cfg.progressDone || '';
    } else {
      wrap.classList.remove('wyde-amp-figma-progress-wrap--complete');
      var money = formatProgressRemainingMoney(cart, remaining);
      var accent =
        '<span class="wyde-amp-figma-rewards-accent" style="color:#000 !important;">' +
        (cfg.progressFreeWord || '') +
        '</span>';
      textEl.innerHTML =
        (cfg.progressRemainingStart || '') +
        '<strong>' +
        money +
        '</strong>' +
        (cfg.progressRemainingMid || '') +
        accent;
    }

    var pct = Math.min(100, Math.max(0, (subtotal / thresh) * 100));
    if (fillEl) fillEl.style.width = pct + '%';
  }

  function sizeLabelFromLineItem(item) {
    if (!item) return '';
    var opts = item.options_with_values;
    if (opts && opts.length) {
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (o && o.name && /^size$/i.test(String(o.name).trim()) && o.value) {
          return String(o.value);
        }
      }
    }
    var vt = item.variant_title;
    if (vt && String(vt).trim() && String(vt).trim().toLowerCase() !== 'default title') {
      return String(vt).trim();
    }
    return '';
  }

  function injectCartLineSizes(cart) {
    var root = getRoot();
    if (!root || !cart || !cart.items) return;
    var cfg = getCfg();
    var prefix = (cfg.sizeLabelPrefix || 'Size') + ': ';

    var titles = root.querySelectorAll('.cart-item__name-label');
    if (!titles.length) return;

    for (var i = 0; i < titles.length; i++) {
      var item = cart.items[i];
      var label = sizeLabelFromLineItem(item);
      var titleEl = titles[i];
      var line = titleEl.closest('.cart-item__info');
      var existing =
        titleEl.nextElementSibling &&
        titleEl.nextElementSibling.classList &&
        titleEl.nextElementSibling.classList.contains('wyde-amp-figma-cart-line-size')
          ? titleEl.nextElementSibling
          : line
            ? line.querySelector('.wyde-amp-figma-cart-line-size')
            : null;

      if (!label) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        continue;
      }

      var text = prefix + label;
      if (existing) {
        existing.textContent = text;
        continue;
      }

      var div = document.createElement('div');
      div.className = 'wyde-amp-figma-cart-line-size';
      div.setAttribute('data-wyde-figma-size', '1');
      div.textContent = text;
      titleEl.parentNode.insertBefore(div, titleEl.nextSibling);
    }
  }

  var progressFetchTimer = null;
  function updateProgressBanner() {
    if (progressFetchTimer) clearTimeout(progressFetchTimer);
    progressFetchTimer = setTimeout(function () {
      progressFetchTimer = null;
      fetchCartAugmentations();
    }, 200);
  }

  function fetchCartAugmentations() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyProgressFromCart(cart);
        syncFooterShippingFromCart(cart);
        injectCartLineSizes(cart);
      })
      .catch(function () {});
  }

  function wireCouponAccordion() {
    var root = getRoot();
    if (!root) return;
    var box = root.querySelector('.amp-cart__discount-box');
    if (!box || box.dataset.wydeFigmaCouponWired) return;
    var title = box.querySelector('.amp-cart__discount-box-title');
    var form = box.querySelector('.amp-cart__discount-box-form');
    if (!title || !form) return;
    box.dataset.wydeFigmaCouponWired = '1';

    function toggle() {
      var open = box.classList.toggle('wyde-amp-figma-coupon-open');
      title.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    title.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });
    title.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });

    var errEl = box.querySelector('[data-wyde-discount-error]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var code = input && input.value ? String(input.value).trim() : '';
      if (!code) return;
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = '';
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: code })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return { ok: r.ok, body: body };
          });
        })
        .then(function (x) {
          if (!x.ok || (x.body && (x.body.errors || x.body.error))) {
            throw new Error('discount');
          }
          [
            'cart:updated',
            'cart:refresh',
            'ajaxCart:updated',
            'shopify:cart:update'
          ].forEach(function (n) {
            try {
              document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
              window.dispatchEvent(new CustomEvent(n, { bubbles: true }));
            } catch (err) {}
          });
          try {
            if (window.jQuery) {
              window.jQuery(document).trigger('cart:updated');
            }
          } catch (jq) {}
          updateProgressBanner();
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd.refresh === 'function') {
            try {
              cd.refresh();
            } catch (re) {}
          }
        })
        .catch(function () {
          var msg = getCfg().discountError || '';
          if (errEl) {
            errEl.textContent = msg;
            errEl.hidden = false;
          }
        });
    });
  }

  function ensureCartLinesScrollHost() {
    var root = getRoot();
    if (!root || !root.querySelector('.cart-drawer__items')) return;

    var scroll = root.querySelector('.cart-drawer__content');
    var results = root.querySelector('.cart-drawer__results');
    var blocks = root.querySelector('.cart-drawer__blocks');
    var itemsBlock = root.querySelector('.cart-drawer__block--items');
    var header = root.querySelector('cart-drawer-header.cart-drawer__header');
    if (!scroll || !results || !blocks || !itemsBlock) return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var targets;
    if (isMobile) {
      targets = [header, blocks].filter(Boolean);
    } else {
      targets = [itemsBlock];
    }

    var existingHost = scroll.querySelector('.wyde-amp-figma-lines-scroll-host');
    if (existingHost) {
      var currentChildren = Array.prototype.slice.call(existingHost.children);
      var same = currentChildren.length === targets.length;
      if (same) {
        for (var i = 0; i < targets.length; i++) {
          if (currentChildren[i] !== targets[i]) {
            same = false;
            break;
          }
        }
      }
      if (same) return;
      while (existingHost.firstChild) {
        existingHost.parentNode.insertBefore(existingHost.firstChild, existingHost);
      }
      existingHost.parentNode.removeChild(existingHost);
    }

    var host = document.createElement('div');
    host.className = 'wyde-amp-figma-lines-scroll-host';
    host.setAttribute('data-wyde-lines-scroll', '1');

    if (isMobile) {
      if (blocks.parentNode === results) {
        results.insertBefore(host, blocks);
      } else {
        results.appendChild(host);
      }
    } else {
      itemsBlock.parentNode.insertBefore(host, itemsBlock);
    }

    for (var j = 0; j < targets.length; j++) {
      host.appendChild(targets[j]);
    }
  }

  function applyCartDrawerScrollIsolation() {
    var root = getRoot();
    if (!root || !root.querySelector('.cart-drawer__items')) return;

    var main = root.querySelector('.cart-drawer__body-main-content');
    var content = root.querySelector('.cart-drawer__content');
    var host = root.querySelector('.wyde-amp-figma-lines-scroll-host');
    var lines = root.querySelector('.cart-drawer__items');

    function col(el) {
      if (!el) return;
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'column', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('height', '100%', 'important');
      el.style.setProperty('max-height', '100dvh', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    }

    col(main);
    col(content);

    if (host) {
      host.style.setProperty('flex', '1 1 auto', 'important');
      host.style.setProperty('min-height', '0', 'important');
      host.style.setProperty('overflow-x', 'hidden', 'important');
      host.style.setProperty('overflow-y', 'auto', 'important');
      host.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      host.style.setProperty('overscroll-behavior', 'contain', 'important');
    }

    if (lines) {
      lines.style.removeProperty('flex');
      lines.style.removeProperty('min-height');
      lines.style.removeProperty('overflow-y');
      lines.style.removeProperty('overflow');
    }
  }

  function ensurePaymentIcons() {
    var root = getRoot();
    if (!root) return;
    var footer = root.querySelector('cart-drawer-footer.cart-drawer__footer');
    if (!footer || footer.querySelector('.wyde-amp-figma-pay-icons')) return;

    var btn = footer.querySelector('[data-cart-checkout-button]');
    if (!btn || !btn.parentNode) return;

    var row = document.createElement('div');
    row.className = 'wyde-amp-figma-pay-icons';
    row.setAttribute('aria-hidden', 'true');
    var P = PAY_CARD_IMG;
    function payMark(title, src, w, h) {
      var width = w != null ? w : 32;
      var height = h != null ? h : 20;
      return (
        '<img class="wyde-amp-figma-pay__img" src="' +
        src +
        '" alt="' +
        title +
        '" title="' +
        title +
        '" width="' +
        width +
        '" height="' +
        height +
        '" loading="lazy" decoding="async" />'
      );
    }

    row.innerHTML =
      '<div class="wyde-amp-figma-pay-icons__row">' +
      payMark('Visa', P.visa) +
      payMark('American Express', P.amex) +
      payMark('Mastercard', P.mc) +
      payMark('Apple Pay', P.apple) +
      payMark('Google Pay', P.google) +
      payMark('PayPal', P.paypal) +
      payMark('Shop Pay', P.shop) +
      '</div>';

    if (btn.nextSibling) {
      btn.parentNode.insertBefore(row, btn.nextSibling);
    } else {
      btn.parentNode.appendChild(row);
    }
  }

  function run() {
    if (document.documentElement.hasAttribute('data-wyde-theme-cart-disabled')) return;
    if (window.__WYDE_UPCART__ && typeof window.__WYDE_UPCART__.isActive === 'function') {
      try {
        if (window.__WYDE_UPCART__.isActive()) return;
      } catch (_) {}
    }
    var root = getRoot();
    if (!root) return;
    if (!root.querySelector('.cart-drawer__items')) return;

    ensureCartLinesScrollHost();
    wireCouponAccordion();
    updateProgressBanner();
    ensurePaymentIcons();
    applyCartDrawerScrollIsolation();
  }

  var runTimer = null;
  function scheduleRun() {
    if (runTimer) clearTimeout(runTimer);
    runTimer = setTimeout(run, 80);
  }

  var obs = new MutationObserver(function () {
    scheduleRun();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRun);
  } else {
    scheduleRun();
  }

  window.addEventListener('resize', scheduleRun, { passive: true });
})();
